import {
  transparentize,
  // lighten,
} from 'polished'

// const white = 'GhostWhite'
// const black = '#301934'  // Dark Purple

const theme = {
  font: 'exo2',
  colors: {
    palette: {
      darkBlack: '#000000',
      lightBlack: '#28282B',  // matte
      ghostWhite: 'GhostWhite',
      clamShell: '#d5b7ab',
    },
    get contrast() {
      return {
        darkBlack: transparentize(0.3, this.palette.darkBlack),
        ghostWhite: transparentize(0.3, this.palette.ghostWhite),
      }
    },
    get indicator() {
      return {
        active: this.palette.ghostWhite,
        inactive: transparentize(0.6, this.palette.ghostWhite),
      }
    },
    get link() {
      return {
        regular: this.palette.ghostWhite,
        get hover() {
          return transparentize(0.5, this.regular)
        },
      }
    },
    get techSlugs() {
      return {
        bgHex: this.palette.darkBlack,
        fallbackHex: '#808080',  // gray
      }
    },
  },
  screens: {
    // large: '1200px',
    medium: '990px',  // width where item shrinking stops
    small: '480px',
  },
  sizes: {
    padding: {
      sectionMedium: '14px',
    },
    heights: {
      border: '2px',
      header: '120px',
      section: '480px',
      sectionMedium: '800px',
      title({
        sectionNumber,
        isMedium,
      }:{
        sectionNumber:number,
        isMedium:boolean,
      }) {
        const border:number = parseInt(this.border)
        const header:number = parseInt(this.header)
        const section:number = parseInt((isMedium)
          ? this.sectionMedium
          : this.section
        )

        return `${sectionNumber*border + header + sectionNumber*section}px`
      },
    },
  },
}

export default theme
